module.exports = __webpack_public_path__ + "static/img/方太平嵌式高端系列.f1cb84d3.png";